{
    "columns": [
      {
        "header_id": "clientAuth",
        "header_label": "Authorization Number",
        "jsonpath": "clientAuth",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "consumerFirstName",
        "header_label": "First Name",
        "jsonpath": "consumerFirstName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "consumerLastName",
        "header_label": "Last Name",
        "jsonpath": "consumerLastName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "medicaid",
        "header_label": "CIN",
        "jsonpath": "medicaid",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "consumerPPLId",
        "header_label": "PPL Id",
        "jsonpath": "consumerPPLId",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "codeDesc",
        "header_label": "Service Code",
        "jsonpath": "codeDesc",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "modifierCode1",
        "header_label": "Modifier",
        "jsonpath": "modifierCode1",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "authFrequencyLkp",
        "header_label": "Authorization Type",
        "jsonpath": "authFrequencyLkp",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "estimatedMidWeekUnits",
        "header_label": "Calc. Weekly Hrs",
        "jsonpath": "estimatedMidWeekUnits",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "formattedAuthHours",
        "header_label": "Auth Hours",
        "jsonpath": "formattedAuthHours",
        "isDisplayedAtHeader": "y",
        "isSearchable": "n"
      },
      {
        "header_id": "units",
        "header_label": "Total Units (15 mins increment)",
        "jsonpath": "units",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "usedUnits",
        "header_label": "Used Units",
        "jsonpath": "usedUnits",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "usedUnitsPercentage",
        "header_label": "Used Unit %",
        "jsonpath": "usedUnitsPercentage",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "startDate",
        "header_label": "Auth Start Date",
        "jsonpath": "startDate",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "endDate",
        "header_label": "Auth End Date",
        "jsonpath": "endDate",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "sourceValue",
        "header_label": "Source",
        "jsonpath": "sourceValue",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "orgName",
        "header_label": "MCO/Agency",
        "jsonpath": "orgName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "statusLkp",
        "header_label": "Status",
        "jsonpath": "statusLkp",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "modifiedDate",
        "header_label": "Modified Date",
        "jsonpath": "modifiedDate",
        "isDisplayedAtHeader": "n",
        "isSearchable": "n"
      },
      {
        "header_id": "isDeleted",
        "header_label": "Deactivated",
        "jsonpath": "isDeleted",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "estimatedFirstWeekUnits",
        "header_label": "Calc. 1st Week Hrs",
        "jsonpath": "estimatedFirstWeekUnits",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "estimatedLastWeekUnits",
        "header_label": "Calc. Last Week Hrs",
        "jsonpath": "estimatedLastWeekUnits",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      }
    ],
    "buttons": [
      {
        "button_id":"Approve",
        "button_label":"Approve",
        "buttonAction" : "approve",
        "className": "primary-btn-color"
      },
      {
        "button_id":"Deny",
        "button_label":"Deny",
        "buttonAction" : "Deny",
        "className": "primary-btn-color"
      }
    ],
    "apiDetails": "authorizationsList.json",
    "pageName": "consumer-auth",
    "orderByColumn": ["modifiedDate"],
    "orderBy": ["desc"]
  }
  